import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Font } from '@react-pdf/renderer'
import robo from "./Roboto-Regular.ttf"
import roboBold from "./Roboto-Bold.ttf"

Font.register({ family: "Roboto", src: robo})
Font.register({ family: "Roboto", src: roboBold, fontWeight: "bold"})

const target = document.querySelector("#search-results");
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  target
);